import Progress from 'easy-circular-progress';
import { Inject } from 'vue-di-container';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import LoaderService from '../../Services/LoaderService';
import { Toaster } from '../../Services/toast';
import ValidationService from '../../Services/ValidationService';
import UserModel from '../../shared/userService/Model/UserModel';
import UserRoleService from '../../shared/userService/UserRoleService';
import UserService from '../../shared/userService/UserService';
import { ReportModel } from '../Report/ReportModel';
import ReportService from '../Report/ReportService';
import WithRender from './ConnectingRequestDashboard.html';
import { ContractDashboardBoxesModel } from './ContractDashboardBoxesModel';
import ConnectingRequestDashboardService from './ConnectingRequestDashboardService';
import { FilterModel } from './FilterModel';
import { ContractSenderRequestModel } from './ContractSenderRequestModel';
import { ContractOptionsModel } from './ContractOptionsModel ';
import { RejectionReasonModel } from '../RejectionReason/RejectionReasonModel';
import ProviderStatusService from '../../shared/ProviderStatusService/ProviderStatusService';
import OperatorService from '@/Services/OperatorService';
import DashboardService from '../Dashboard/DashboardService';


@WithRender
@Component({
    components: {
        Progress,
    },
    diProvide: [
        ConnectingRequestDashboardService,
        UserService,
        ReportService,
        UserRoleService,
        ProviderStatusService,
        OperatorService,
        DashboardService,

    ],
    computed: {
        favoriteIconColor(): string {
            const theme = process.env.VUE_APP_TITLE || 'Default';
            console.log('theme in Dashboard:', theme);
            switch (theme) {
                case 'Mobily':
                    return '#5EC1D9';
                case 'Zain':
                    return '#76C57E';
                default:
                    return '#D09BE6';
            }
        },
    }
})
export default class ConnectingRequestDashboard extends Vue {
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Inject(UserService) public userService!: UserService;
    @Inject(ConnectingRequestDashboardService) public connectingRequestDashboardService!: ConnectingRequestDashboardService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(ReportService) public reportService!: ReportService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(ProviderStatusService) public providerStatusService!: ProviderStatusService;
    @Inject(DashboardService) public dashboardService!: DashboardService;
    public providerLocked: boolean = true;
    public providerDissconected: boolean = true;
    public providerExpired: boolean = true;
    public layoutSup: boolean | any;
    public requestStatuses: string = '';
    public senderStatus: string = '';
    public Deleteids: string[] = [];
    public deleteDialog: boolean = false;
    public approveids: string[] = [];
    public approveDialog: boolean = false;
    public resendids: string[] = [];
    public resendDialog: boolean = false;
    public resendComment: string = '';
    public contractFilterOption: number = -1;
    public contractFilterExpiryOption: number = 0;
    public createdDateToMenu: boolean = false;
    public createdDateFromMenu: boolean = false;
    public approveComment: string = '';
    public senderId: string = '';
    public deleteComment: string = '';
    requestStatusBox: string[] = [];
    public favoriteDialog: boolean = false;
    public unfavoriteDialog: boolean = false;
    public requestsFilterExpiryOption: number = 0;
    public operatorOptions: any[] = [];

    public contractDateRequestOptions: any =
        [
            { "id": 0, "name": "All" },
            { "id": 1, "name": "Oldest" },
            { "id": 2, "name": "Newest" },
        ];
    public contractDateRequestExpiryOptions: any =
        [
            { "id": 1, "name": "90 Days" },
            { "id": 2, "name": "30 Days" },
            { "id": 3, "name": "7 Days" },
        ];
    public requestsDateExpiryOptions: any = [
        { id: 1, name: '90 Days' },
        { id: 2, name: '30 Days' },
        { id: 3, name: '7 Days' },
    ];

    public popUpRejectionReasons: RejectionReasonModel[] = [];
    public selectedRejectReason: RejectionReasonModel = {} as RejectionReasonModel;
    public isItOtherReasonPorp: boolean = false;
    public filterModel: FilterModel = {
        senderName: '',
        clientName: '',
        createdDate: '',
        providerName: '',
        requestId: '',
        displayId: '',
        status: [],
        createdDateFrom: '',
        createdDateTo: ''
    };
    public reportModel: ReportModel = {
        requestId: '',
        displayId: '',
        senderName: '',
        tenantName: '',
        approveDateFrom: '',
        approveDateTo: '',
        createdDateFrom: '',
        createdDateTo: '',
        customerType: 0,
        senderType: 0,
        providerId: '',
        clientName: '',
        comment: '',
        representativeName: '',
        representativeMobile: '',
        representativeEmail: '',
        requestStatus: [],
        senderStatus: 0,
        numberOfActions: 0,
        paymentDate: '',
        expiryDate: '',
        filterContractOption: 0,
        filterExpiryOption: 0,
        requestsFilterExpiryOption: 0,
        pageIndex: '0',
        pageSize: '10',
    };
    public statusOptions: any[] = [
        {
            id: '1',
            name: this.$t('dashboardPage.pendingFor').toString()
                + ' ' + this.$t('dashboardPage.approval').toString(),
        },
        {
            id: '2',
            name: this.$t('dashboardPage.pendingFor').toString()
                + ' ' + this.$t('dashboardPage.payment').toString(),
        },
        {
            id: '3',
            name: this.$t('dashboardPage.rejected').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '4',
            name: this.$t('dashboardPage.inactive').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '5',
            name: this.$t('dashboardPage.active').toString()
                + ' ' + this.$t('dashboardPage.requests').toString(),
        },
        {
            id: '7',
            name: this.$t('dashboardPage.partially').toString()
                + ' ' + this.$t('dashboardPage.activated').toString(),
        },
    ];
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            TenantId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public autoInterval: any;
    public userRole: number = -1;
    /** CITC/CST Admin & User: view and export only (no contract processing actions). */
    public get isCstReadOnly(): boolean {
        return this.userRole === 3 || this.userRole === 4;
    }
    public scrollDiv: any;
    public nextPage: string = '';
    public scrollTop: number = 0;
    public selected: ContractSenderRequestModel[] = [];
    public selectedIds: string[] = [];
    public ids: string[] = [];
    public senders: ContractSenderRequestModel[] = [];
    public sendersCount: number = 0;
    public dashboardBoxes: ContractDashboardBoxesModel = {} as ContractDashboardBoxesModel;
    public contractOptions: ContractOptionsModel = {
        isNewContractEnabled: false,
        isRenewContractEnabled: false,
        isExtendSenderDurationEnabled: false,
    };
    public User: any;
    public rejectResone: string = '';
    public rejectdialog: boolean = false;
    public anySelected: boolean = false;
    public pagination: any = {};
    public tenantId: string = '';
    public isFromFilterBox: boolean = false;
    public headers: any = [
        { text: this.$t('dashboardPage.displayId'), sortable: true, value: 'displayId', align: 'center' },
        { text: this.$t('dashboardPage.senderName'), sortable: true, value: 'senderName', align: 'center' },
        { text: this.$t('dashboardPage.clientName'), sortable: true, value: 'clientName', align: 'center' },
        {
            text: this.$t('dashboardPage.providerName'), sortable: true,
            value: 'providerName', align: 'center',
        },
        {
            text: this.$t('dashboardPage.requestDate'), sortable: true,
            value: 'createdDate', align: 'center',
        },
        {
            text: this.$t('dashboardPage.expiryDate'), sortable: true,
            value: 'expiryDate', align: 'center',
        },
        { text: this.$t('dashboardPage.operatorStatus'), sortable: false, align: 'center' },
        {
            text: this.$t('dashboardPage.status'), sortable: false, value: 'requestStatus',
            align: 'center', width: '190',
        },
        {
            text: this.$t('dashboardPage.senderExpiryDate'), sortable: false, value: 'senderexpiryDate', align: 'center'
        },
        { text: this.$t('shared.actions'), sortable: false, align: 'center', width: '145' },
    ];
    public isWithinTwoHours(date: string | Date): boolean {

        if (!date)
            return false;

        const created = new Date(date);
        const now = new Date();

        return (now.getTime() - created.getTime()) <= 2 * 60 * 60 * 1000;
    }

    public changeSort(column: any) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.updatePaginate(this.pagination);
    }
    public checkColor(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return '#c427ba';
                break;
            }
            case '2': {
                return '#5aaa0b';
                break;
            }
            case '3': {
                return '#C42727';
                break;
            }
            case '4': {
                return '#aaa7a7';
                break;
            }
            case '5': {
                return '#014bb1';
                break;
            }
            case '7': {
                return '#5c9bf2';
                break;
            }
            case '10': {
                return '#9b2a5a';
                break;
            }
            default: {
                return '#F78500';
                break;
            }
        }
    }
    public GetSenderStatus(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return 'Pending Approval';
                break;
            }
            case '2': {
                return 'Approved';
                break;
            }
            case '3': {
                return 'Rejected';
                break;
            }
            case '4': {
                return 'Paid';
                break;
            }
            case '5': {
                return 'Expired';
                break;
            }
            case '6': {
                return 'Deleted';
                break;
            }
            case '7': {
                return 'Partially Activated';
                break;
            }
            case '10': {
                return 'Pending For Review';
                break;
            }
            default: {
                return '';
                break;
            }
        }
    }
    public async created() {
        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.operatorOptions = response.result;
        }
    }
    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User) as number;
        if (this.userRole === 2 || this.userRole === 5) {
            this.isProviderLocked();
            this.isProviderExpired();
            this.isProviderDissconected();
        }
        if (this.userRole === 1 || this.userRole === 9 || this.userRole === 15) {
            this.getRejectionReasons();
        }
        this.dashboardBoxes = await this.connectingRequestDashboardService.GetDashboardBoxes();
        this.tenantId = this.User.details.TenantId;
        this.getContractOptions();
        this.search();
    }
    public async getContractOptions() {
        const response = await this.connectingRequestDashboardService.getContractOptions();
        this.contractOptions.isNewContractEnabled = response.result.isNewContractEnabled;
        this.contractOptions.isRenewContractEnabled = response.result.isRenewContractEnabled;
        this.contractOptions.isExtendSenderDurationEnabled = response.result.isExtendSenderDurationEnabled;
    }
    public showFavoriteDialog(senderId: string) {

        this.senderId = senderId;
        this.favoriteDialog = true;
    }

    public hideFavoriteDialog() {
        this.favoriteDialog = false;
    }

    public showUnfavoriteDialog(senderId: string) {

        this.senderId = senderId;
        this.unfavoriteDialog = true;
    }

    public hideUnfavoriteDialog() {
        this.unfavoriteDialog = false;
    }

    public async favorClient() {

        const response = await this.connectingRequestDashboardService.FavorClient(
            this.senderId);

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('shared.clientFavoriteSuccessfully').toString());
            await this.reload();
        }
        this.hideFavoriteDialog();
    }

    public async unfavorClient() {

        const response = await this.connectingRequestDashboardService.UnfavorClient(
            this.senderId,
        );

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('shared.clientUnfavoriteSuccessfully').toString());
            await this.reload();
        }
        this.hideUnfavoriteDialog();
    }
    public async isProviderLocked() {
        const response = await this.connectingRequestDashboardService.isProviderLocked();
        this.providerLocked = response.result;
    }
    public async isProviderExpired() {
        const response = await this.connectingRequestDashboardService.isProviderExpired();
        this.providerExpired = response.result;
    }
    public async isProviderDissconected() {
        const response = await this.providerStatusService.isProviderDissconected();
        this.providerDissconected = response.result;
    }

    public async reset() {
        localStorage.removeItem('storSettings');
        this.filterModel = {
            senderName: '',
            requestId: '',
            displayId: '',
            clientName: '',
            providerName: '',
            createdDate: '',
            createdDateFrom: '',
            createdDateTo: '',
            status: [],
        };
        this.contractFilterOption = -1;
        this.contractFilterExpiryOption = 0;
        this.requestsFilterExpiryOption = 0;
        this.pagination = {
            page: 1,
            rowsPerPage: 10,
            sortBy: '',
            descending: false,
        };
        if (!this.isFromFilterBox && (this.requestStatusBox.length > 0 || !this.requestStatusBox.includes('0'))) {

            this.requestStatusBox = ['0'];
        }
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        await this.search();
    }

    public async search() {
        let model;
        if (localStorage.storSettings) {
            const storSettings = JSON.parse(localStorage.storSettings);
            this.pagination = storSettings.pagination;
            model = storSettings.filter;
            this.filterModel.senderName = storSettings.filter.senderName;
            this.filterModel.requestId = storSettings.filter.requestId;
            this.filterModel.displayId = storSettings.filter.displayId;
            this.filterModel.clientName = storSettings.filter.clientName;
            this.filterModel.providerName = storSettings.filter.providerName;
            this.filterModel.createdDate = storSettings.filter.createdDate;
            this.filterModel.status = storSettings.filter.requestStatuses;
            this.senderStatus = storSettings.filter.senderStatus;
            this.contractFilterOption = storSettings.filter.contractFilterOption;
            this.contractFilterExpiryOption = storSettings.filter.contractFilterExpiryOption;
            this.requestsFilterExpiryOption = storSettings.filter.requestsFilterExpiryOption || 0;
            this.filterModel.createdDateFrom = storSettings.filter.createdDateFrom;
            this.filterModel.createdDateTo = storSettings.filter.createdDateTo;
        } else {
            model = {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                sortDirection: false,
                contractFilterOption: this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
                contractFilterExpiryOption: this.contractFilterExpiryOption,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                sortBy: '',
                pageIndex: '0',
                pagesize: this.pagination.rowsPerPage,
            };
        }
        localStorage.removeItem('storSettings');
        const response = await this.connectingRequestDashboardService.Get(model);
        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            }
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
    }

    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value2.includes(value1));
    }

    public async filter(requestStatus: string) {
        // requestStatusBox toggle
        if (requestStatus === '0') {
            //"All" selected, reset everything else
            this.requestStatusBox = ['0'];
        } else {
            // Remove "All" if already selected
            this.requestStatusBox = this.requestStatusBox.filter(s => s !== '0');

            const index = this.requestStatusBox.indexOf(requestStatus);
            if (index === -1) {
                // not selected → add 
                this.requestStatusBox.push(requestStatus);
            } else {
                // already selected → remove 
                this.requestStatusBox.splice(index, 1);
            }
        }

        // update filterModel 
        if (this.requestStatusBox.length > 0) {
            this.isFromFilterBox = true;
            this.filterModel.status = this.requestStatusBox.map(s => parseInt(s, 10));
        } else {
            this.filterModel.status = [];
        }
        this.pagination.page = 1;

        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 10) : 0,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            sortDirection: this.pagination.descending,
            sortBy: this.pagination.sortBy,
            contractFilterOption: this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
            contractFilterExpiryOption: this.contractFilterExpiryOption,
            requestsFilterExpiryOption: this.requestsFilterExpiryOption,
            pageIndex: (this.pagination.page - 1).toString(),
            pagesize: this.pagination.rowsPerPage,
        };


        const response = await this.connectingRequestDashboardService.Get(model);

        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }

        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.isFromFilterBox = false;
    }

    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedIds = [];
        } else {
            this.selected = this.senders.filter(sender => {
                return (sender.requestStatus);
            }).slice();
            this.selectedIds = this.senders.filter(sender => {
                return (sender.requestStatus);
            }).map((x) => x.id);
        }
    }
    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
        }
    }
    public getRate(remainingDays: string, totalDays: string) {
        return (parseInt(remainingDays, 10) / parseInt(totalDays, 10)) * 100;
    }

    public showapproveDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        }
        if (this.senders.filter((s) => this.selectedIds.includes(s.id) && s.automaticallyInserted)
            .length > 0) {
            Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
            return;
        }
        this.approveDialog = true;
    }
    public hideapproveDialog() {
        this.approveComment = '';
        this.approveDialog = false;
    }
    public async approve(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '1')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
                return;
            }
            if (this.senders.filter((s) => ids.includes(s.id) && s.tenantId !== this.tenantId)
                .length > 0 && this.userRole === 1) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
                return;
            }
            if (this.senders.filter((s) => ids.includes(s.id) && s.automaticallyInserted)
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
                return;
            }
        }
        const response = await this.connectingRequestDashboardService.approve(ids, this.approveComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            await this.reload();
            this.selectedIds = [];
        } else {
            Toaster.success(this.$t('dashboardPage.Approvedsuccessfully').toString());
            await this.connectingRequestDashboardService.contractApproveEmail(ids);
            await this.reload();
            this.selectedIds = [];
        }
        this.hideapproveDialog();
    }

    public showDeleteDialog(id: string) {
        this.Deleteids = [];
        if (id !== '') {
            this.Deleteids.push(id);
        } else {
            this.Deleteids = this.selectedIds;
        }
        this.deleteDialog = true;
    }
    public hideDeleteDialog() {
        this.deleteDialog = false;
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public showresendDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        } else {
            this.resendids = this.selectedIds;
        }
        if (this.senders.filter((s) => this.selectedIds.includes(s.id) && s.automaticallyInserted)
            .length > 0) {
            Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
            return;
        }
        this.resendDialog = true;
    }
    public async addRequest() {
        let isRenew: string = 'false';
        this.$router.push({ name: 'ConnectingSenderName', params: { isRenew } });

    }
    public async checkRenewContractRow(id: string) {
        let ids: string[] = [];
        ids.push(id);
        const response = await this.connectingRequestDashboardService.checkRenewContract(ids);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            await this.reload();
            this.selectedIds = [];
        } else {
            this.$router.push({ name: 'RenewContractRequest', params: { ids: ids.join(',') } });
        }
    }
    public async checkRenewContract() {

        if (this.isAnySelected) {
            let ids: string[] = [];
            ids = this.selectedIds;
            const response = await this.connectingRequestDashboardService.checkRenewContract(ids);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
                await this.reload();
                this.selectedIds = [];
            } else {
                this.$router.push({ name: 'RenewContractRequest', params: { ids: ids.join(',') } });
            }
        }
        else {
            let isRenew: string = 'true';
            this.$router.push({ name: 'ConnectingSenderName', params: { isRenew } });
        }

    }

    public async checkRenewSender(senderId: string) {

        let ids: string[] = [];
        if (senderId !== '') {
            ids.push(senderId);

            const response = await this.dashboardService.checkRenewSender(ids);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
                await this.reload();
            } else {
                const joined = ids.join(',');
                this.$router.push({
                    name: 'RenewRegisterSender',
                    params: { ids: joined },
                    query: { renewalSource: 'contractDashboard', ids: joined },
                });
            }
        } else {
            this.$router.push({
                name: 'RenewRegisterSender',
                query: { renewalSource: 'contractDashboard' },
            });
        }
    }
    public hideresendDialog() {
        this.resendComment = '';
        this.resendDialog = false;
    }
    public async exportToExcel() {
        this.loaderService.ShowLoader();
        this.reportModel.requestStatus = this.filterModel.status;
        this.reportModel.senderStatus = this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0;
        this.reportModel.filterContractOption = this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
            this.reportModel.requestId = this.filterModel.requestId;
        this.reportModel.displayId = this.filterModel.displayId;
        this.reportModel.senderName = this.filterModel.senderName;
        this.reportModel.clientName = this.filterModel.clientName;
        this.reportModel.createdDateFrom = this.filterModel.createdDateFrom;
        this.reportModel.createdDateTo = this.filterModel.createdDateTo;
        this.reportModel.filterExpiryOption = this.contractFilterExpiryOption;
        this.reportModel.requestsFilterExpiryOption = this.requestsFilterExpiryOption;
        const response = await this.reportService.GetContractRequestsReport
            (this.reportModel, '0', '0', true);
        if (!response.isSuccess) {
            this.loaderService.HideLoader();
            Toaster.error(response.errorMessage);
        } else {
            this.loaderService.HideLoader();
        }
    }

    public async deleteSender() {
        let ids: string[] = [];
        ids = this.Deleteids;
        if (this.senders.filter((s) => ids.includes(s.id) && !(s.requestStatus.toString() === '4'
            || s.requestStatus.toString() === '2')).length > 0) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderApprovedOrPaid').toString());
            return;
        }
        const response = await this.connectingRequestDashboardService.delete(ids[0], this.deleteComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.deleteDialog = false;
            await this.reload();
        } else {
            this.deleteDialog = false;
            this.selectedIds = [];
            this.connectingRequestDashboardService.deleteRequestEmail(this.Deleteids);
            Toaster.success(this.$t('shared.deleteSuccessfully').toString());
            await this.reload();
        }
    }
    public async resend(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) && s.automaticallyInserted)
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
                return;
            }
            if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '3')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRejected').toString());
                return;
            }
        }
        const response = await this.connectingRequestDashboardService.resend(ids, this.resendComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            await this.connectingRequestDashboardService.resendContractRequestEmail(ids);
            this.selectedIds = [];
            Toaster.success(this.$t('dashboardPage.resentSuccessfully').toString());
            await this.reload();
        }
        this.hideresendDialog();
    }
    public async showRejectDialog(item?: ContractSenderRequestModel) {
        this.ids = [];
        if (item) {
            this.ids.push(item.id);
            if ([2, 5].includes(this.userRole)) {

                if (item.providerRejected) {
                    Toaster.error(this.$t('dashboardPage.providerAlreadyRejected').toString());
                    return;
                }
                if (!this.isWithinTwoHours(item.createdDateTime)) {
                    Toaster.error(this.$t('dashboardPage.providerRejectTimeExpired').toString());
                    return;
                }
                if (!this.popUpRejectionReasons) {
                    this.popUpRejectionReasons = [];
                }
                if ([2, 5].includes(this.userRole)) {
                    const providerReason = { id: "0", rejectionText: 'Rejected by provider', requestType: 1 } as RejectionReasonModel;

                    if (!this.popUpRejectionReasons.some(x => x.rejectionText === providerReason.rejectionText)) {
                        this.popUpRejectionReasons.unshift(providerReason);
                    }

                    this.selectedRejectReason = providerReason;
                    this.rejectResone = providerReason.rejectionText;

                } else {
                    this.popUpRejectionReasons = this.popUpRejectionReasons.filter(
                        x => x.rejectionText !== 'Rejected by provider'
                    );

                    if (this.selectedRejectReason && this.selectedRejectReason.rejectionText === 'Rejected by provider') {
                        this.selectedRejectReason = { id: '', rejectionText: '', requestType: 0 } as RejectionReasonModel;
                        this.rejectResone = '';
                    }

                }
    
            }
        } else {
            this.ids = this.selectedIds;
        }


            if (this.senders.filter((s) => this.ids.includes(s.id) && s.requestStatus.toString() !== '1')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingApproval').toString());
                return;
            }
            if (this.senders.filter((s) => this.ids.includes(s.id) && s.automaticallyInserted)
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
                return;
            }

            this.rejectdialog = true;
        }
    public async hideRejectDialog() {
        this.rejectResone = '';
        this.rejectdialog = false;
    }
    public async reject() {
        if (this.senders.filter((s) => this.ids.includes(s.id) && s.tenantId !== this.tenantId)
            .length > 0 && this.userRole === 1) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
            return;
        }
        if (this.rejectResone !== '') {
            this.rejectdialog = false;
            const response = await this.connectingRequestDashboardService.reject(this.ids, this.rejectResone);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                if (![2, 5].includes(this.userRole))
                await this.connectingRequestDashboardService.rejectContractRequestEmail(this.ids);
                this.rejectResone = '';
                this.selectedIds = [];
                this.ids = [];
                Toaster.success(this.$t('dashboardPage.Rejectedsuccessfully').toString());
                await this.reload();
            }
        }
    }
    public PreparePay(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            if (this.senders.filter((s) => ids.includes(s.id) && s.requestStatus.toString() !== '2')
                .length > 0) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingPay').toString());
                return;
            }
        }
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatus: this.requestStatuses !== '' ? parseInt(this.requestStatuses, 0) : 0,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                contractFilterOption: this.contractFilterOption,
                contractFilterExpiryOption: this.contractFilterExpiryOption,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
                pageIndex: (this.pagination.page - 1).toString(),
                pageSize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'Payment', params: { ids: ids.join(',') } });
    }
    public Details(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pageSize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
                contractFilterOption: this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
                contractFilterExpiryOption: this.contractFilterExpiryOption,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'ContractRequestInfo', params: { id } });
    }
    public ChangeSenderType(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatus: this.requestStatuses !== '' ? parseInt(this.requestStatuses, 0) : 0,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pageSize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
                contractFilterOption: this.contractFilterOption,
                contractFilterExpiryOption: this.contractFilterExpiryOption,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'ChangeSenderType', params: { id } });
    }
    public UpdateRequestData(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                requestId: this.filterModel.requestId,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatus: this.requestStatuses !== '' ? parseInt(this.requestStatuses, 0) : 0,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pageSize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
                contractFilterOption: this.contractFilterOption,
                contractFilterExpiryOption: this.contractFilterExpiryOption,
                requestsFilterExpiryOption: this.requestsFilterExpiryOption,
                createdDateFrom: this.filterModel.createdDateFrom,
                createdDateTo: this.filterModel.createdDateTo,
                requestStatuses: this.filterModel.status,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'UpdateContractRequest', params: { id } });
    }
    public ConectivityDetail(senderId: string) {
        this.$router.push({ name: 'ContractConnectivityDetail', params: { senderId } });
    }
    public async updatePaginate(val: any) {
        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
            pageIndex: (val.page - 1).toString(),
            pagesize: val.rowsPerPage,
            contractFilterOption: this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
            contractFilterExpiryOption: this.contractFilterExpiryOption,
            requestsFilterExpiryOption: this.requestsFilterExpiryOption,
            sortDirection: this.pagination.descending,
            sortBy: this.pagination.sortBy,
        };
        const response = await this.connectingRequestDashboardService.Get(model);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
    }
    public get isAnySelected(): boolean {
        this.anySelected = this.selectedIds.length > 0;
        return this.anySelected;
    }
    public async reload() {
        this.contractFilterExpiryOption = 0;
        this.requestsFilterExpiryOption = 0;
        const model = {
            senderName: this.filterModel.senderName,
            requestId: this.filterModel.requestId,
            displayId: this.filterModel.displayId,
            clientName: this.filterModel.clientName,
            providerName: this.filterModel.providerName,
            createdDate: this.filterModel.createdDate,
            createdDateFrom: this.filterModel.createdDateFrom,
            createdDateTo: this.filterModel.createdDateTo,
            requestStatuses: this.filterModel.status,
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
            pageIndex: '0',
            pagesize: '10',
            contractFilterOption: this.contractFilterOption === -1 ? 0 : this.contractFilterOption,
            contractFilterExpiryOption: 0,
            requestsFilterExpiryOption: 0,
            sortDirection: false,
            sortBy: '',
        };
        const response = await this.connectingRequestDashboardService.Get(model);
        this.dashboardBoxes = await this.connectingRequestDashboardService.GetDashboardBoxes();
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.selectedIds = [];
        this.selected = [];
        if (this.pagination != undefined) {
            this.pagination.rowsPerPage = 10;
            this.pagination.page = 1;
        }
    }

    private internalUpdate = false;

    @Watch('contractFilterOption', { deep: true })
    public async onchangeContractFilter() {
        if (!this.internalUpdate) {
            this.internalUpdate = true;
            this.contractFilterExpiryOption = 0;
            await this.$nextTick();
            this.search();
            this.internalUpdate = false;
        }
    }

    @Watch('contractFilterExpiryOption', { deep: true })
    public async onchangeContractFilterExpiry() {
        if (!this.internalUpdate) {
            this.internalUpdate = true;
            this.contractFilterOption = -1;
            await this.$nextTick();
            this.search();
            this.internalUpdate = false;
        }
    }

    @Watch('requestsFilterExpiryOption', { deep: true })
    public async onchangeRequestsFilterExpiryOption() {
        await this.search();
    }

    public get rejectReasonIsValid(): boolean {
        return this.rejectResone !== '';
    }

    public async getRejectionReasons() {
        const response = await this.connectingRequestDashboardService.getSenderNameRejectReasons(2);
        this.popUpRejectionReasons = response.result;
    }
    public handleItemChange() {
        if (this.selectedRejectReason.id == '0') {
            this.isItOtherReasonPorp = true;
            this.rejectResone = '';
        }
        else {
            this.isItOtherReasonPorp = false;
            this.rejectResone = this.selectedRejectReason.rejectionText
        }
    }
    public get isItOtherReason(): boolean {
        return this.isItOtherReasonPorp;
    }

    private searchTimeout: any = null;

    public onInputSearch() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.search();
        }, 500);
    }

    public onDateChange(field: 'from' | 'to') {
        if (field === 'from') this.createdDateFromMenu = false;
        if (field === 'to') this.createdDateToMenu = false;

        this.search();
    }

}
